import { IMAGE_MIME_TYPES } from "@lib/constants/mime"

export const getFileType = (file: File) => {
  if (file.type) {
    // Validate that the file.type is in our accepted image mime types
    if (IMAGE_MIME_TYPES.has(file.type)) {
      return file.type
    }
    // If file.type exists but isn't in our accepted types, return it anyway
    // (might be a valid image type we haven't added yet)
    return file.type
  }

  if (!file.name) {
    throw new Error("Unable to determine file type for file " + file)
  }

  const extension = file.name.toLowerCase().split(".").at(-1)
  if (!extension) {
    throw new Error("Unable to determine file type extension for file " + file.name)
  }

  // Map extension to mime type
  const extensionToMime: Record<string, string> = {
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    webp: "image/webp",
    heic: "image/heic",
    heif: "image/heif",
    tiff: "image/tiff",
    tif: "image/tiff",
  }

  const mimeType = extensionToMime[extension]
  // Only return mime types that are in our accepted IMAGE_MIME_TYPES set
  if (mimeType && IMAGE_MIME_TYPES.has(mimeType)) {
    return mimeType
  }

  throw new Error("Unsupported file type for file " + file.name)
}